// Polis, l'onglet des candidats et de leur popularité (10 octobre 2026).
export default {
  titre: 'Popularité des candidats',
  luLe: 'Lue le {jour}',
  jamaisLu: 'Pas encore lue',
  lecture: 'Note de 0 à 100 selon ce qui se dit de chacun, 50 étant neutre',
  suivi: 'Chaque soir',
  lire: 'Lire maintenant',
  enCours: 'Lecture en cours',
  premiereEnCours: 'Première lecture en cours : Orion lit la semaine écoulée de chaque candidat.',
  aucuneLecture: 'Aucune lecture encore. La première lit la semaine écoulée de chaque candidat.',
  courbeAria: 'La note de chaque candidat, jour par jour',
  legende: 'Mettre un candidat en avant',
  vue: { aria: 'Vue', radar: 'Radar', suivi: 'Suivi' },
  mesure: { aria: 'Recouper par', personas: 'Personas', entourage: 'Entourage' },
  recoupement: {
    bouton: 'Recoupements',
    aria: '{a} et {b} se recoupent à {pct} %',
    titre: 'Recoupement',
    personasPct: 'de leurs électeurs viennent des mêmes personas',
    sansPersonas: 'Leurs électeurs ne viennent pas des mêmes personas.',
    communs: 'Les personas en commun',
    seul: 'Seulement chez {nom}',
    rienSeul: 'Rien qui lui soit propre',
    entouragePct: 'de porosité entre leurs électorats',
    procheDe: '{pct} % des électeurs de {de} ont un proche qui vote {vers}.',
    sansEntourage: 'Leurs électeurs se côtoient peu.',
    recoupePersonas: 'Ses électeurs recoupent ceux de',
    recoupeEntourage: 'Ses électeurs côtoient ceux de',
  },
  et: 'et',
  radarAria: 'Les candidats sur le radar, de la gauche à la droite',
  lectureRadar: {
    projection: 'Au centre, ceux que la projection place le plus haut ; plus une tête est grande, plus on en parle.',
    attente: 'La projection placera les candidats dès la première vague terminée ; plus une tête est grande, plus on en parle.',
    personas: 'Un trait relie deux candidats dont les électeurs viennent des mêmes personas.',
    entourage: 'Un trait relie deux candidats dont les électeurs se côtoient.',
  },
  projection: {
    titrePct: 'Premier tour',
    titreSieges: 'Projection',
    pct: '{n} %',
    sieges: '{n} sièges',
    fourchette: '{bas} ~ {haut}',
    second: 'de chances d’être au second tour',
    seuil: 'de chances de passer le seuil',
    colonne: 'Projection',
  },
  note: { titre: 'Ce qui se dit', colonne: 'Note' },
  classement: 'Classement',
  electeurs: {
    // Ses personas, chacun avec sa voix, et on leur parle (11 octobre 2026).
    titre: 'Ses personas',
    citation: '« {texte} »',
    tous: 'Tous ses électeurs : {profil}',
    sources: 'Construits à partir des votes des jumeaux et de l’intelligence d’Orion, dont {n} études et sources. | Construits à partir des votes des jumeaux et de l’intelligence d’Orion, dont {n} étude ou source. | Construits à partir des votes des jumeaux et de l’intelligence d’Orion, dont {n} études et sources.',
    parler: 'Leur parler',
    parlerA: 'Parler aux électeurs « {segment} »',
    qui: { femme: 'femme', homme: 'homme', ans: '{n} ans' },
    age: 'âge médian {n} ans',
    femmes: '{n} % de femmes',
    tropPeu: 'Trop peu d’électeurs à la dernière vague pour les décrire.',
    sansVague: 'Les électeurs se décrivent après une vague de vote.',
    source: 'Projection, électeurs et recoupements : {vague}.',
    sourceEnCours: 'Électeurs et recoupements : {vague}, en cours.',
    // Le Sonar de l'élection (11 octobre 2026).
    interroger: 'Parler à tous ses électeurs',
  },
  changerPhoto: 'Changer la photo de {nom}',
  photoOrion: 'Reprendre la photo d’Orion',
  surCent: 'sur 100',
  surSemaine: 'sur 7 jours',
  surJour: 'depuis la veille',
  pasEncoreLu: 'Pas encore lu.',
  deLaVoix: 'de la voix',
  courbeCandidat: 'La note de {nom} sur la période',
  repartitionAria: '{favorable} % favorable, {neutre} % neutre, {defavorable} % défavorable',
  favorable: 'favorable',
  neutre: 'neutre',
  defavorable: 'défavorable',
  ceQuiSeDit: 'Ce qu’on en dit',
  peuDeMatiere: 'Peu de matière ce jour-là : la note bouge vite.',
  chargement: 'Les candidats se lisent…',
  erreur: 'Les candidats n’ont pas pu se lire.',
  fermer: 'Fermer',
}
